import {Injectable} from '@angular/core';
import {AbstractRestService} from './rest-abstract.service';

@Injectable()
export class RestService extends AbstractRestService {

  getRootUrl(): string {
    return this.globals.rest_url;
  }
}
